import { useNavigate } from "react-router-dom";
import Thumbnail from "./thumbnail";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";;
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { useSelector } from "react-redux";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";
import PageTitle from "../../../../../common/components/PageTitle";

export default function TrackOrder() {
  const navigate = useNavigate();
  const { height, width } = useWindowDimensions();
  const [data, getdata] = useState<any>();
  const { register, handleSubmit, clearErrors, formState: { errors } } = useForm();
  const { header, footer, visible, theme, primary, secondary } = useSelector(selectCurrent)

  const handleChange: any = (event: any, field: string) => {
    getdata({ ...data, [field]: event })
  }

  const trackOrder = () => {
    console.log('orderNumber', data.orderNumber)
    navigate('/customer/order/order-tracking', { state: { orderId: data.orderNumber } })
  }

  return (
    <>
      {width && width < 720 ?
        //  Start - Mobile View  
        <div className={`max-h-screen w-screen mt-20 py-5 px-4`}>
          <div className="flex flex-col justify-center items-center py-5 w-full">
            <div className="text-2xl text-qblack font-semibold">
              Track your Order
            </div>
          </div>
          <div className="flex flex-col justify-around w-full bg-white p-5 items-center rounded">
            <div className="text-sm text-gray-400 text-start w-full pb-2">
              Enter your Order Tracking Number:
            </div>
            <div className="w-full">
              <input
                type="text"
                {...register('orderNumber', {
                  required: true,
                })}
                className="border p-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Track Number"
                onChange={(event) => {
                  handleChange(
                    event.target.value,
                    'orderNumber'
                  );
                }}
                value={data?.orderNumber}
              />
            </div>
            <div className="flex justify-center items-center py-5">
              <button onClick={() => { trackOrder() }} className={`bg-primary text-light hover:bg-secondary font-semibold px-4 py-2 rounded`}>
                Track Now
              </button>
            </div>
            <div className="flex justify-center mt-20">
              <Thumbnail />
            </div>
          </div>
        </div>
        //  End - Mobile View  
        :
        <div className="tracking-page-wrapper w-full p-5">
          <div className="page-title mb-[40px]">
            <PageTitle
              title="Track Order"
              breadcrumb={[
                { name: "home", path: "/" },
                { name: "Track Order", path: "/customer/order/track" },
              ]}
            />
          </div>
          <div className="content-wrapper w-full mb-[40px]">
            <div className="container-x mx-auto">
              <h1 className="text-[22px] text-qblack font-semibold leading-9">
                Track Your Order
              </h1>
              <p className="text-[15px] text-qgraytwo leading-8 mb-5">
                Enter your order tracking number and your secret id.
              </p>
              <div className="w-full bg-white lg:px-[30px] px-5 py-[23px] lg:flex items-center">
                <div className="lg:w-[642px] w-full">
                  <div className="mb-3">

                    <input
                      type="text"
                      {...register('orderNumber', {
                        required: true,
                      })}
                      className="border-0 px-3 py-3 w-1/2 h-16 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Track Number"
                      onChange={(event) => {
                        handleChange(
                          event.target.value,
                          'orderNumber'
                        );
                      }}
                      value={data?.orderNumber}
                    />
                  </div>
                  <div className="flex justify-start">
                    <button
                      onClick={() => { trackOrder() }}
                      className={`bg-primary text-white hover:bg-[bg-skin-primary] font-semibold px-2 py-2 h-16 w-60`}
                    >
                      Track Now
                    </button>
                  </div>
                </div>
                <div className="flex-1 flex justify-center mt-5 lg:mt-0">
                  <Thumbnail />
                </div>
              </div>
            </div>
          </div>
        </div>
      }</>


  );
}
